import React, { PureComponent } from "react";
import classnames from "classnames";
import { FormattedMessage } from "@al/next/al-ex";

import getAppName from "~/common/utils/getAppName";

import styles from "./styles.scss";

export enum StatusType {
  NoService = "noService",
  Finished = "finished",
}

type PageStatusProps = {
  onRefresh?: () => void;
  className?: string;
  style?: React.CSSProperties;
  status?: StatusType;
};

export default class PageStatus extends PureComponent<PageStatusProps> {
  handleRefresh = (): void => {
    if (this.props.onRefresh) {
      this.props.onRefresh && this.props.onRefresh();
    } else {
      location.reload();
    }
  };

  render(): JSX.Element {
    const { className, style, status = StatusType.NoService } = this.props;
    const appName = getAppName();
    const text = {
      [StatusType.NoService]: "页面无服务，尝试刷新试试看",
      [StatusType.Finished]: "活动已结束",
    }[status];
    return (
      <div
        className={classnames(styles.root, className, styles[appName], styles[status])}
        style={style}
        onTouchStart={(e): void => e.stopPropagation()}
      >
        <div className={styles.img} />
        <div className={styles.text}>
          <FormattedMessage keys={`global:${text}`} />
        </div>
        {status === StatusType.NoService ? (
          <div className={styles.btn} onClick={this.handleRefresh}>
            <FormattedMessage keys="global:重新刷新" />
          </div>
        ) : null}
      </div>
    );
  }
}
